<template>
<div>    
 
  <div class="card border border-primary">
  <div class="card-header bg-primary text-white">
    <h4>    
    <i style="color:#FFCC00" class="fas fa-binoculars mr-3" aria-hidden="true"></i>
    RICERCA PRODOTTO </h4>
  </div>
  <div class="card-body">
    <form name="productSearch" v-on:submit.prevent="getData()">            
            <div v-if="!otherParams">             
              <inputSearch @update="setData"></inputSearch>          
            </div>
          
            <div v-else>
            <div class="form-row">
              <div class="col-md-3">
                <company-brand-select v-bind:props="brand"  @update="setBrandId"></company-brand-select>   
              </div>

              <div class="col-md-3">
                <category-select v-bind:props="category"  @update="setCategoryId"></category-select>    
              </div>
              <div class="col-md-3">
              
                <season-select v-bind:props="season"  @update="setSeasonId"></season-select>
              </div>
              <div class="col-md-3">
                <year-select  v-bind:props="season_year" @update="setYear"></year-select>   
              </div>
              <div class="col">
                <sizeSelect  v-bind:props="size" @update="setSizeId"></sizeSelect>   
              </div>
            </div>
           
            

            </div>
            
            
            <button :disabled="spinner" type="submit" class="btn btn-primary mb-1 mr-4 ml-4">
              <i class="fas fa-binoculars mr-2" aria-hidden="true"></i>
                CERCA
              <span v-if="spinner" class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
            </button> 
            

            <button :disabled="spinner" type="button" @click="refresh()" class="btn btn-secondary mb-1  ">
              <i style="color:yellow" class="fas fa-sync mr-2" aria-hidden="true"></i>
                ALTRI PARAMETRI DI RICERCA
             
            </button> 

       


 </form>




    <alert-box class="mt-1" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
    <div class="table-wrapper-scroll-y my-custom-scrollbar">

    <table class="table table-hover table-bordered table-sm table-striped mb-0">
    <thead >
      <tr class="table-primary">
        <th scope="col">#</th>
        <th scope="col">ID PRODTTO</th>
        <th scope="col">BRAND</th>
        <th scope="col">CATEGORIA</th>
        
        <th scope="col">CODICE</th>
        <th scope="col">COLORE</th>
        <th scope="col">MISURA</th>
        <th class="text-right" scope="col">ESISTENZA</th>
        
        <th scope="col">DESCRIZIONE</th>
        <th scope="col">REPARTO</th>
        <th scope="col">STAGIONE</th>
        <th class="text-right" scope="col">LISTINO</th>
        <th scope="col">EAN GESTIONALE</th>
        <th scope="col">EAN FORNITORE</th>
       
      </tr>
    </thead>
    <tbody>
      
      <tr :style="styleObject(item)" data-toggle="tooltip" title="Doppio click seleziona la variante prodotto" class="pointer" v-on:dblclick="setProduct(item)"  v-for="(item, index) in filteredProducts" :key="index">
        <td>{{index+1}}</td>
        <td>{{item.productId}}</td>

        <td>{{item.brand}}</td>
         <td>{{item.category}}</td>
        
        <td><strong>{{item.sku}}</strong></td>
        <td>{{item.color}} </td>
        <td>{{item.size}} </td>        
        <td class="text-right">{{item.qtyStock}} </td>
        
        
        <td>{{item.description}}</td>
        <td>{{item.department}}</td>
        <td>{{item.season}}-{{item.season_year}} </td>
      
        <td class="text-right">{{fmt1(item.price)}}</td>
        <td>{{item.barcode}}</td>
        <td>{{item.supplier_barcode}}</td>
       
      </tr> 
            
    </tbody> 
  </table>
  
  </div>

<filter-key @update="setFilterKey"/>  
 
  </div>
</div>
 
 
               
   
</div>
 





</template>
<script>

import api                 from "@/api";
import alertBox            from '@/components/common/AlertBox.vue'
import filterKey           from '@/components/common/FilterKey.vue'
import categorySelect      from '@/components/common/CategorySelect_1.vue';
import companyBrandSelect  from '@/components/common/CompanyAllBrandSelect_1.vue';
import seasonSelect        from '@/components/common/SeasonSelect_1.vue'
import yearSelect          from '@/components/common/YearSelect_1.vue'
import fmt                 from '@/components/mixins/fmt.js'
import inputSearch         from '@/components/frontOffice/InputSearch.vue'
import sizeSelect          from '@/components/common/SizeSelect_1.vue'

import {mapGetters }       from 'vuex';
export default {
   props      : [''],
   mixins     : [fmt], 
   components : {alertBox,filterKey,categorySelect,companyBrandSelect,seasonSelect,yearSelect,inputSearch,sizeSelect},
  data() {
    return {

      input                  : 
      {        
          id                 : 0,
          search             : '',
      },    
      otherParams            : false,    
      items                  : [],
      filterKey              : '',
      msg                    : {
        title : '',
        body  : '',
        type  : 0
      },      
      spinner                : false,   
      size            : {
        Id            : 0,
        isActive      : true,
        
        optionBase    : true,
        required      : false,
        
      },   
      category        : 
      {
        Id            : 0,
        isActive      : true,
        
        optionBase    : false,
        required      : true,
        groupId       : 0
       
      },
      brand           :
      {
        
        Id            : '%',
        required      : true,
        allBrands     : false,
        focus         : true

      }, 
      season          : 
      {
        Id            : 0,
        isActive      : true,
       
        optionBase    : true,
        required      : false,
        type          : true


      },
      season_year     : 
      {
        year          : 0,
        isActive      : true,
       
        optionBase    : true,
        required      : false

      },     
          
    }
  },
  computed :{
   
    ...mapGetters(['company','storeId']),
    filteredProducts : function () 
      {
        var filterKey = this.filterKey && this.filterKey.toLowerCase()
        var items = this.items
        if (filterKey) {
        items = items.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        })
      }
        return items
     },
     total : function ()
     {
         let total = 0
         this.filteredProducts.forEach(item=>
          {
            total += item.qtyStock
          })
          return total
     }
  },  
  created: function() {

    this.$nextTick(()  => {
        $('#staticBackdropProductSearch').modal('show')               
    })
  
   
  },
  methods: {
   
    setData(data,id)
    {
      this.input.id = id
      this.input.search = data
      
    },
    setSizeId(sizeId)
    {
      this.size.Id = sizeId
    },
   styleObject (item)
   {
    

    let bg_color = ''
    let color = ''

    if(this.input.id == 1 && item.barcode == this.input.search)
    {
       bg_color = 'green'
       color = 'white'
      
      return {'backgroundColor': bg_color,'color': color}

    }
    if(this.input.id == 2 && item.supplier_barcode == this.input.search)
    {
       bg_color = 'green'
       color = 'white'
      
      return {'backgroundColor': bg_color,'color': color}

    }
    
    
    },
    refresh()
    {
          
      this.brandId          = '%'
      this.category.Id      = 0
      this.season.Id        = 0
      this.season_year.year = 0
      this.msg.title        = ''
      this.otherParams      = !this.otherParams
      this.items            = []
      this.input.search     = ''
      this.input.id         = 0
      this.size.Id          = 0
    
    },
    setCategoryId(categoryId)
    {
       
      this.category.Id = categoryId

    },
    setSeasonId(seasonId)
    {
      this.season.Id = seasonId
    },
    setYear(year,e)
    {            
      this.season_year.year = year
    },     
    setBrandId(brandId)
    {
      this.brand.Id = brandId
    },
    setFilterKey(value)
    {
        this.filterKey = value
    },

    setProduct(item)
    {
      const barcode = this.company.Id == 59 ? item.supplier_barcode : item.barcode
      this.$emit('close',barcode)  
      

    },
    async getData() {

      this.msg.title = ''    
      
            
      if(this.input.id == 0 && this.input.search.length < 3 && !this.otherParams)
      {
        this.msg.title = 'ATTENZIONE'              
        this.msg.body  = 'DIGITARE ALMENO 3 CARATTERI.'
        this.msg.type  = 1
        
        return
      }
      
      
      
      this.spinner = true
      this.items   = []
      
    const data     = {


      'productKey'    : this.input.id,
      'productSearch' : this.input.search.replace("'",""),

      'companyId'     : this.company.Id,
      'storeId'       : this.storeId,


      'brand'         : this.brand.Id,
      'categoryId'    : this.category.Id,
      'seasonId'      : this.season.Id,   
      'year'          : this.season_year.year,
      'sizeId'        : this.size.Id

    }
      
      const sp = {'sp' : this.otherParams ? 'spProductSearchOtherParams' : 'spProductSearchAllBarcodes' }
      const json    = Object.assign(data, sp)
      
      await api.post(json).then(res => {
        
      
          if(res.status==200)
            {
              this.items = res.data.recordsets[0]
              
              if(this.items.length==0)
              {
                this.msg.title = 'ATTENZIONE'              
                this.msg.body  = 'DATI INESISTENTI'
                this.msg.type  = 1
                
              }

            }
           else if(res.status==500)
           {
                
                this.msg.title = 'ATTENZIONE ' 
                this.msg.body  = res.data            
                this.msg.type  = 1
                                                  
           } 
           else
            {
                
                this.msg.title = 'ATTENZIONE ' 
                this.msg.body  = res            
                this.msg.type  = 1
                                 
            } 
          

          }).catch(err => {
              
              console.log(err.message)    
              this.msg.title = 'ATTENZIONE ' 
              this.msg.body  = err.message            
              this.msg.type  = 1
              
          }).finally(() => {
              this.spinner = false
        });



    }
  }
};
</script>
<style scoped>

.my-custom-scrollbar {
position: relative;
height: 500px;
overflow: auto;
}
.form-check-label{
  cursor: pointer;
}
.pointer:hover
{
  background-color: blue;
  color: white;
  cursor: pointer;
}
.table-wrapper-scroll-y {
display: block;
}

.table thead tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;


    color       : rgb(16, 16, 15) !important;
    background  : #a9cbe2;
    
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }

h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}
tr {
  font-family: 'Roboto Condensed';
}
.btn_1
{
  background-color: #ec7211 !important;
  color : white;
}


.card-header
{
  height: 45px;
}
input::placeholder {
  font-weight: bold;
  font-size: larger;
  opacity: 0.5;
  color : black;
}
</style>